export default __webpack_public_path__ + "static/media/phoneMissed.974d6c73.svg";